import { apiClient } from '@/lib/api-client'
import type { Concept, ConceptListResponse } from '@/types/terms'

/** The collection's concepts with their terms — fetched once, filtered client-side. */
export async function getConcepts(collectionId: number | null): Promise<Concept[]> {
  const { data } = await apiClient.get<ConceptListResponse>('/concepts', {
    params: {
      limit: 100000,
      search: '',
      lang: '',
      ...(collectionId ? { collection_id: collectionId } : {}),
    },
  })
  return data.concepts ?? []
}

/** Full concept card, including definitions (not present in the list payload). */
export async function getConcept(conceptId: number): Promise<Concept> {
  const { data } = await apiClient.get<Concept>(`/concepts/${conceptId}`)
  return data
}
